import LazyLoad, { ILazyLoadInstance } from "vanilla-lazyload";

let instance: ILazyLoadInstance | null = null;

export function lazyLoadUpdate(): void {
    if (instance !== null){
        instance.update();
        return;
    }

    instance  = new LazyLoad({
        elements_selector: '[loading=lazy]',
        use_native: true,
    })

    instance.update();
}
